import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Wine, Coffee, Baby, Mountain, Music, ArrowRight, Footprints } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import { resolveTrailsList } from "@/lib/layout";

const ICONS = { wine: Wine, coffee: Coffee, baby: Baby, mountain: Mountain, music: Music };

export default function Trails() {
  const { settings } = useSettings();
  useEffect(() => { window.scrollTo(0, 0); }, []);
  const trailList = resolveTrailsList(settings);

  return (
    <div className="px-4 py-6 md:px-8" data-testid="trails-index-page">
      <div className="mb-6">
        <span className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">Curated routes</span>
        <h1 className="flex items-center gap-2 font-serif text-3xl font-bold md:text-4xl">
          <Footprints className="text-primary" /> CSRA Trails
        </h1>
        <p className="mt-1 text-muted-foreground">Hand-picked crawls through the region — just show up and follow the route.</p>
      </div>

      <div className="grid gap-6 md:grid-cols-3">
        {trailList.map((t, i) => {
          const Icon = ICONS[t.icon] || Wine;
          return (
            <motion.div
              key={t.slug}
              initial={{ opacity: 0, y: 18 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: i * 0.08 }}
            >
              <Link to={`/trail/${t.slug}`} data-testid={`trail-card-${t.slug}`}
                className="card-hover group block overflow-hidden rounded-2xl border border-border bg-card">
                <div className="relative h-44 overflow-hidden">
                  <img src={t.hero} alt={t.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/75 to-transparent" />
                  <span className="absolute left-3 top-3 inline-flex items-center gap-1.5 rounded-full bg-primary/90 px-3 py-1 text-[11px] font-semibold uppercase tracking-widest text-primary-foreground">
                    <Icon size={12} /> {t.eyebrow}
                  </span>
                  <h2 className="absolute bottom-3 left-3 right-3 font-serif text-xl font-bold text-white text-shadow-soft">{t.title}</h2>
                </div>
                <div className="p-4">
                  <p className="line-clamp-2 text-sm text-muted-foreground">{t.subtitle}</p>
                  <span className="mt-3 flex items-center gap-1 text-sm font-semibold text-primary">
                    Start the trail <ArrowRight size={15} className="transition-transform group-hover:translate-x-1" />
                  </span>
                </div>
              </Link>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
}
